import ShButton from '@/components/Helpers/ShButton';
import ShDividerLine from '@/components/Helpers/ShDividerLine';
import CollapseAccordion from '@/components/Common/CollapseAccordion';
import PromotionCodesForm from '@/components/PromotionCodes/PromotionCodesForm';

// @vue/component
export default {
  name: 'PrepaidAccountBalance',

  components: {
    ShButton,
    ShDividerLine,
    CollapseAccordion,
    PromotionCodesForm,
  },

  props: {
    user: {
      type: Object,
      defaul: () => ({}),
      required: true,
    },
  },

  data() {
    return {
      minAccountBalanceValue: 20,
      hintIsVisible: false,
      // eslint-disable-next-line max-len
      hintMessageNormal: 'Jeżeli ilość połączeń osiągnie 0 lub minie termin ważności konta, wszystkie widgety umieszczone na Twoich stronach internetowych przestaną być aktywne. W każdej chwili możesz dokupić pakiet połączeń. W tym celu doładuj konto.',
      hintMessageWarning: 'Pozostała mała ilość połączeń na koncie.',
    };
  },

  computed: {
    hintMessage() {
      return this.account.account_balance + this.account.account_balance_of_recording < this.minAccountBalanceValue
        ? this.hintMessageWarning
        : this.hintMessageNormal;
    },
    account() {
      return this.user.access;
    },
    isAccessExpired() {
      return this.$store.getters['authorization/isAccessExpired'];
    },
  },
};
